import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30c36fb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ref } from 'vue'
import { Tabbar, TabbarItem } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'MTabbar',
  setup(__props) {

const tabbarOptions = [
  {
    name: '企服',
    active: require('@/assets/image/tabbar/icon-home.png'),
    inactive: require('@/assets/image/tabbar/icon-home-hover.png'),
    path: '/',
  },
  {
    name: '热门',
    active: require('../../assets/image/tabbar/hot.png'),
    inactive: require('../../assets/image/tabbar/hot-hover.png'),
    path: '/popular-articles',
  },
  {
    name: '资源',
    active: require('../../assets/image/tabbar/resources.png'),
    inactive: require('../../assets/image/tabbar/resources-hover.png'),
    path: '/resource-list',
  },
  {
    name: '视频',
    active: require('../../assets/image/tabbar/video.png'),
    inactive: require('../../assets/image/tabbar/video-hover.png'),
    path: { name: 'video-list' },
  },
  {
    name: '我的',
    active: require('../../assets/image/tabbar/icon-user.png'),
    inactive: require('../../assets/image/tabbar/icon-user-hover.png'),
    path: '/user',
  },
]

const onChange = (val: number) => {
  console.log(val, typeof val)
}
const active = ref(0)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tabbar), {
    class: "tab-box",
    modelValue: active.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
    "active-color": "#3D3D3D",
    route: "",
    onChange: onChange
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabbarOptions, (item) => {
        return _createVNode(_unref(TabbarItem), {
          key: item.name,
          to: item.path
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              class: "tabbar-icon",
              src: props.active ? item.inactive : item.active
            }, null, 8, _hoisted_1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})